<template>
  <div id="h5Index">
    <!-- 侧边栏 -->
    <van-popup 
      v-model="sidebarActive" 
      position="left" 
      :style="{ width: '80%', height: '100%' }"
      @click-overlay="sidebarActive = false"
    >
      <div class="sidebar">
        <div class="sidebar-header">
          <van-button 
            type="primary" 
            size="small" 
            @click="newChat"
            block
          >
            <van-icon name="plus" /> 新对话
          </van-button>
        </div>

        <van-list
          v-model="loadingMore"
          :finished="!hasMore"
          finished-text="没有更多了"
          error-text="加载失败"
          @load="loadMore"
        >
          <div 
            v-for="(chatGroup, groupIndex) in historyTypeList" 
            :key="groupIndex" 
            class="history-group"
          >
            <div class="history_date">{{ chatGroup.date }}</div>
            <van-cell-group>
              <van-cell
                v-for="(chat, chatIndex) in chatGroup.items"
                :key="chatIndex"
                :title="chat.title  || '新对话'"
                :class="{ active: currentChatId === chat.id }"
                @click="selectChat(chat)"
                clickable
                :border="false"
              >
                <template #right-icon>
                  <van-icon 
                    name="delete" 
                    class="history_item_delete" 
                    @click.stop="deleteChat(chat)"
                  />
                </template>
              </van-cell>
            </van-cell-group>
          </div>
        </van-list>

        <div v-if="chatHistory.length === 0" class="empty-tips">
          <van-icon name="chat-o" size="40" />
          <p>暂无对话记录</p>
        </div>

        <div class="sidebar-footer">
          <div class="user-profile">
            <van-icon name="user-o" class="user-avatar" />
            <span class="user-name">{{ userName }}</span>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 聊天头部 -->
      <van-nav-bar
        :title="currentChat.title || '新对话'"
        left-arrow
      >
      <template #left>
        <van-icon name="bars" size="24" @click="toggleSidebar"/>
      </template>
        <template #right>
          <van-button 
            v-if="isStreaming" 
            size="small" 
            type="danger" 
            @click="stopStream"
          >
            停止
          </van-button>
          <van-button 
            v-else-if="currentChat.messages.length > 1" 
            size="small" 
            @click="clearCurrentChat"
          >
            清空
          </van-button>
        </template>
      </van-nav-bar>

      <!-- 聊天容器 - 修改样式确保可以滚动 -->
      <div class="chat-container-wrapper">
        <div ref="chatContainer" class="chat-container">
          <div class="chat-content">
            <div
              v-for="(message, index) in currentChat.messages"
              :key="`message-${index}-${message.timestamp || index}`"
              class="message"
              :class="message.role"
            >
              <div class="message-content" v-if="message.content">
                <div class="message-text">{{ message.content }}</div>
                <div v-if="message.timestamp" class="message-time">
                  {{ formatTime(message.timestamp) }}
                </div>
              </div>
            </div>

            <!-- 正在输入动画 -->
            <div v-if="isTyping" class="message assistant typing">
              <div class="typing-indicator">
                <van-loading size="16px" />
                <span>DeepSeek 正在思考...</span>
              </div>
            </div>

            <!-- 空状态 -->
            <div v-if="currentChat.messages.length === 0" class="empty-chat">
              <van-icon name="comment-o" size="40" />
              <h3>开始新的对话</h3>
              <p>输入消息开始与 DeepSeek AI 助手对话</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 输入区域 -->
      <div class="input-area">
        <div class="input-container">
          <van-field
            v-model="inputMessage"
            type="textarea"
            :autosize="{ maxHeight: 100 }"
            placeholder="输入消息... (Enter发送)"
            @keydown.enter.exact.prevent="sendMessage"
            rows="1"
            :disabled="isStreaming"
            ref="chatInput"
          />
          <van-button
            :class="{ disabled: !canSend }"
            :disabled="!canSend"
            type="primary"
            size="small"
            @click="sendMessage"
            class="send-button"
          >
            <van-icon :name="isStreaming ? 'stop' : 'arrow-up'" />
          </van-button>
        </div>
        <div class="input-tips">
          <span v-if="isStreaming" class="streaming-tip"
            >DeepSeek 正在回复中...</span
          >
          <span v-else class="default-tip">DeepSeek 可以回答各种问题</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deepseekList, deepseekdel, deepseekChatMessage } from "@/api/deepseek";
import config from "../../../config/index";
const WELCOME_MESSAGE = "你好！我是DeepSeek，很高兴为你服务。有什么我可以帮助你的吗？";
export default {
  name: "DeepSeekChat",
  data() {
    return {
      sidebarActive: false,
      inputMessage: "",
      isTyping: false,
      currentChatId: null,
      chatHistory: [],
      historyTypeList: [],
      platForm: "",
      userId: "",
      userName:'',
      oriApi:'',

      // 分页控制
      currentPage: 1,
      pageSize: 10,
 hasMore: true,       // ✅ 初始为 true
    loadingMore: false,  // ✅ 初始为 false
      // 流式传输控制
      streamController: null,
      isStreaming: false,
      currentAssistantMessage: "",
      scrollTimer: null,
      currentTypingQueue: [],
      isAnimatingType: false,
      typingTimeout: null,
      isFirstSendAfterNewChat: false,
      refreshTimer: null,
      currentChatConversationId: null,
      needRefreshHistory: false,
      refreshDebounceTimer: null,
    };
  },

  computed: {
    currentChat() {
      if (!this.currentChatId && this.chatHistory.length > 0) {
        return this.chatHistory[0];
      }
      return (
        this.chatHistory.find((chat) => chat.id === this.currentChatId) ||
        this.getDefaultChat()
      );
    },

    canSend() {
      return this.inputMessage.trim() && !this.isStreaming;
    },
  },

  methods: {
    // 发送消息
    async sendMessage() {
      if (!this.canSend) return;

      const userMessage = this.inputMessage.trim();
      console.log("发送消息:", userMessage);

      // 添加用户消息
      this.addUserMessage(userMessage);

      // 更新标题（首次提问）
      this.updateChatTitle(userMessage);

      this.inputMessage = "";
      this.resetInputHeight();
      
      // 立即滚动到底部（用户消息）
      this.$nextTick(() => {
        this.scrollToBottom(true);
      });

      // 开始流式传输
      await this.startStreamResponse(userMessage);
    },

    // 添加用户消息
    addUserMessage(content) {
      this.currentChat.messages.push({
        role: "user",
        content: content,
        timestamp: Date.now(),
      });
    },

    // 更新聊天标题
    updateChatTitle(userMessage) {
      if (this.currentChat.messages.length === 2) {
        // 用户第一条消息
        this.currentChat.title =
          userMessage.substring(0, 20) + (userMessage.length > 20 ? "..." : "");
      }
    },

    // 开始流式响应
    async startStreamResponse(userMessage) {
      this.isTyping = true;
      this.isStreaming = true;

      // 重置流式状态
      this.currentAssistantMessage = "";
      this.currentTypingQueue = [];
      if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
        this.typingTimeout = null;
      }
      this.isAnimatingType = false;

      // 添加空的助手消息
      const assistantMessageIndex = this.currentChat.messages.length;
      this.currentChat.messages.push({
        role: "assistant",
        content: "",
        timestamp: Date.now(),
      });

      // 确保滚动到新消息位置
      this.$nextTick(() => {
        this.scrollToBottom(true);
      });

      try {
        await this.streamChatCompletion(userMessage, assistantMessageIndex);
      } catch (error) {
        this.handleStreamError(error, assistantMessageIndex);
      } finally {
        this.isTyping = false;
        this.isStreaming = false;
      }
    },

    // 流式聊天完成 - 针对你的SSE格式优化
    async streamChatCompletion(userMessage, messageIndex) {
      this.streamController = new AbortController();
      const signal = this.streamController.signal;
      const conversationId = this.currentChat.conversationId;
      try {
        const response = await fetch(
          config.apiHttpsUrl + "/general/api/chat/stream",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              message: userMessage,
              platForm: this.platForm,
              userId: this.userId,
              userName: this.userName,
              conversationId: conversationId,
            }),
            signal,
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        if (!response.body) {
          throw new Error("Response body is null");
        }

        await this.processStreamResponse(response, messageIndex);
      } catch (error) {
        if (error.name !== "AbortError") {
          throw error;
        }
      }
    },

    // 处理流式响应 - 优化SSE解析
    async processStreamResponse(response, messageIndex) {
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          console.log("流式传输完成");
          this.handleStreamComplete(messageIndex);
          break;
        }

        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;

        // 处理完整的SSE消息
        const messages = this.extractCompleteSSEMessages(buffer);
        buffer = messages.remainingBuffer;

        // 处理每个完整的SSE消息
        for (const message of messages.completeMessages) {
          this.processSSEMessage(message, messageIndex);
        }

        // 每次接收到数据都尝试滚动到底部
        this.scheduleScrollToBottom();

        // 优化性能：批量更新UI
        await this.$nextTick();
      }
    },

    // 提取完整的SSE消息
    extractCompleteSSEMessages(buffer) {
      const completeMessages = [];
      let remainingBuffer = buffer;

      while (true) {
        const messageEndIndex = remainingBuffer.indexOf("\n\n");

        if (messageEndIndex === -1) {
          break;
        }

        const messageText = remainingBuffer.substring(0, messageEndIndex);
        completeMessages.push(messageText);

        remainingBuffer = remainingBuffer.substring(messageEndIndex + 2);
      }

      return {
        completeMessages,
        remainingBuffer,
      };
    },

    // 处理单个SSE消息
    processSSEMessage(messageText, messageIndex) {
      console.log("原始SSE消息:", messageText);

      const lines = messageText.split("\n");
      let data = null;
      let eventType = "message";

      for (const line of lines) {
        const trimmedLine = line.trim();
        if (!trimmedLine) continue;

        if (trimmedLine.startsWith("event:")) {
          eventType = trimmedLine.substring(6).trim();
        } else if (trimmedLine.startsWith("data:")) {
          const dataStr = trimmedLine.substring(5).trim();
          if (dataStr === "[DONE]") {
            this.handleStreamComplete(messageIndex);
            return;
          }

          if (dataStr) {
            try {
              data = JSON.parse(dataStr);
            } catch (e) {
              console.warn("JSON解析失败:", dataStr, e);
              if (dataStr.startsWith("{") || dataStr.startsWith("[")) {
                console.error("JSON解析错误的数据:", dataStr);
              } else {
                data = { content: dataStr, type: "text" };
              }
            }
          }
        }
      }

      if (data) {
        this.handleStreamData(data, eventType, messageIndex);
      }
    },

    // 处理流式数据 - 根据事件类型处理
    handleStreamData(data, eventType, messageIndex) {
      let content = "";

      if (data.content || data.text) {
        content = data.content || data.text;
      } else if (data.message && typeof data.message === "string") {
        content = data.message;
      } else if (typeof data === "string") {
        content = data;
      }

      if (!content || typeof content !== "string") return;
      if (data.conversationId) {
        this.currentChat.conversationId = data.conversationId;
      }

      this.typeTextGradually(content, messageIndex);
    },
    
    // 逐字显示函数
    typeTextGradually(text, messageIndex) {
      const chars = text.split("");
      this.currentTypingQueue.push(...chars);

      if (!this.isAnimatingType) {
        this.animateTyping(messageIndex);
      }
    },

    // 动画执行函数
    animateTyping(messageIndex) {
      if (this.isStreaming === false && this.currentTypingQueue.length === 0) {
        this.isAnimatingType = false;

        if (this.isFirstSendAfterNewChat) {
          this.isFirstSendAfterNewChat = false;
          this.needRefreshHistory = true;
          this.scheduleHistoryRefresh();
        }

        this.handleStreamComplete(messageIndex);
        return;
      }

      this.isAnimatingType = true;

      const char = this.currentTypingQueue.shift();
      if (char !== undefined) {
        this.currentAssistantMessage += char;
        this.currentChat.messages[messageIndex].content = this.currentAssistantMessage;
        
        // 每次添加字符时都尝试滚动
        this.scheduleScrollToBottom();

        const delay = Math.random() * 40 + 30;
        this.typingTimeout = setTimeout(() => {
          this.animateTyping(messageIndex);
        }, delay);
      } else {
        if (this.isStreaming) {
          this.typingTimeout = setTimeout(() => {
            this.animateTyping(messageIndex);
          }, 50);
        } else {
          this.isAnimatingType = false;

          if (this.isFirstSendAfterNewChat) {
            this.isFirstSendAfterNewChat = false;
            this.needRefreshHistory = true;
            this.scheduleHistoryRefresh();
          }

          this.handleStreamComplete(messageIndex);
        }
      }
    },

    // 添加智能刷新方法
    scheduleHistoryRefresh() {
      if (this.refreshDebounceTimer) {
        clearTimeout(this.refreshDebounceTimer);
      }

      this.refreshDebounceTimer = setTimeout(() => {
        if (this.needRefreshHistory) {
          this.getHistory().finally(() => {
            this.needRefreshHistory = false;
          });
        }
      }, 1000);
    },

    // 处理流完成
    handleStreamComplete(messageIndex) {
      if (
        messageIndex >= 0 &&
        messageIndex < this.currentChat.messages.length
      ) {
        this.currentChat.messages[messageIndex].content =
          this.currentAssistantMessage || "";
      }

      this.saveChatToHistory();
      // 流完成时确保滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom(true);
      });
    },

    // 处理流错误
    handleStreamError(error, messageIndex) {
      console.error("流式错误:", error);

      if (this.currentChat.messages[messageIndex]?.content === "") {
        this.currentChat.messages.splice(messageIndex, 1);
      }

      const errorMessage = this.getErrorMessage(error);
      this.currentChat.messages.push({
        role: "assistant",
        content: errorMessage,
        timestamp: Date.now(),
      });

      this.$nextTick(() => {
        this.scrollToBottom(true);
      });
    },

    // 获取错误消息
    getErrorMessage(error) {
      if (error.message.includes("HTTP error! status: 200")) {
        return "连接已建立，但数据处理异常";
      } else if (error.message.includes("fetch")) {
        return "网络连接失败，请检查网络设置";
      } else if (error.name === "AbortError") {
        return "生成已停止";
      } else {
        return `抱歉，请求失败：${error.message}`;
      }
    },

    // 停止流式传输
    stopStream() {
     if (this.streamController) {
    this.streamController.abort();
  }

  this.isStreaming = false;

  if (this.typingTimeout) {
    clearTimeout(this.typingTimeout);
    this.typingTimeout = null;
  }

  // 合并剩余字符并结束
  if (this.currentTypingQueue.length > 0) {
    this.currentAssistantMessage += this.currentTypingQueue.join("");
    this.currentTypingQueue = [];
  }

  // 更新最后一条助手消息
  const lastMsg = this.currentChat.messages[this.currentChat.messages.length - 1];
  if (lastMsg && lastMsg.role === "assistant") {
    lastMsg.content = this.currentAssistantMessage || lastMsg.content;
  }

  // 🔥 关键：重置流式状态
  this.isTyping = false;
  this.currentAssistantMessage = "";
  this.isAnimatingType = false;

  this.saveChatToHistory();

  this.$nextTick(() => {
    this.scrollToBottom(true);
  });
    },

    // 清空当前对话
    clearCurrentChat() {
      this.$dialog.confirm({
        title: '确认',
        message: '确定要清空当前对话吗？'
      }).then(() => {
        this.currentChat.messages = [
          {
            role: "assistant",
            content:
              "你好！我是DeepSeek，很高兴为你服务。有什么我可以帮助你的吗？",
            timestamp: Date.now(),
          },
        ];
        this.$nextTick(() => {
          this.scrollToBottom(true);
        });
      }).catch(() => {});
    },

    // 新建聊天
    newChat() {
    // 1. 停止可能正在进行的流式请求
  this.stopStream();

  // 2. 强制重置流式状态（关键修复）
  this.isStreaming = false;
  this.isTyping = false;
  this.currentAssistantMessage = "";
  this.currentTypingQueue = [];
  this.isAnimatingType = false;
  if (this.typingTimeout) {
    clearTimeout(this.typingTimeout);
    this.typingTimeout = null;
  }

  // 3. 创建新聊天
  const newChat = this.getDefaultChat();

  // 4. 将新聊天添加到历史记录的开头
  this.chatHistory.unshift(newChat);
  // 更新分组列表
  this.historyTypeList = this.groupByDay(this.chatHistory);
  // 设置为当前聊天
  this.currentChatId = newChat.id;
  this.sidebarActive = false;

  // 5. 标记为首次发送，用于后续刷新历史（可选）
  this.isFirstSendAfterNewChat = true;

  // 6. 确保视图滚动到底部
  this.$nextTick(() => {
    this.scrollToBottom(true);
  });
    },

    // 选择聊天
    selectChat(chat) {
      this.stopStream();
      this.currentChatId = chat.id;

      const selectedChat = this.chatHistory.find((c) => c.id === chat.id);
      if (selectedChat) {
        this.currentChat.conversationId = selectedChat.id;
      }
      console.log("当前聊天ID:", this.currentChat);
      this.getMessageInfo();
      this.sidebarActive = false;
      this.$nextTick(() => {
        this.scrollToBottom(true);
      });
    },

    // 获取默认聊天
    getDefaultChat() {
        const defaultChat = {
    id: Date.now(),
    title: "新对话",
    conversationId: null,
    messages: [
      {
        role: "assistant",
        content: WELCOME_MESSAGE,
        timestamp: Date.now(),
      },
    ],
    updatedAt: new Date().toISOString(),
  };
  
  // 使用 JSON 方法创建新对象
  return JSON.parse(JSON.stringify(defaultChat));
    },

    // 保存聊天到历史记录
    saveChatToHistory() {
      // 查找 chatHistory 中是否有对应的聊天记录
  const index = this.chatHistory.findIndex(chat => chat.id === this.currentChat.id);
  if (index !== -1) {
    // 如果存在，则用 currentChat 的最新状态替换它
    // 注意：这里我们使用 JSON.parse(JSON.stringify()) 来创建一个深拷贝
    // 以确保响应式更新
    this.$set(this.chatHistory, index, JSON.parse(JSON.stringify(this.currentChat)));
  } else {
    // 如果不存在（理论上不应该发生，但为了安全）
    this.chatHistory.unshift(JSON.parse(JSON.stringify(this.currentChat)));
  }
  // 重新分组以更新侧边栏显示
  this.historyTypeList = this.groupByDay(this.chatHistory);
    },

    // 输入处理
    handleInput() {
      this.autoResize();
    },

    // 自动调整输入框高度
    autoResize() {
      this.$nextTick(() => {
        const el = this.$refs.chatInput?.$refs?.textarea;
        if (el) {
          el.style.height = "auto";
          el.style.height = Math.min(el.scrollHeight, 200) + "px";
        }
      });
    },

    resetInputHeight() {
      this.$nextTick(() => {
        const el = this.$refs.chatInput?.$refs?.textarea;
        if (el) {
          el.style.height = "auto";
        }
      });
    },

    // 滚动控制 - 增强版
    scrollToBottom(force = false) {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer;
        if (container) {
          // 计算是否需要滚动
          const scrollTop = container.scrollTop;
          const scrollHeight = container.scrollHeight;
          const clientHeight = container.clientHeight;
          const distanceToBottom = scrollHeight - scrollTop - clientHeight;
          
          // 如果强制滚动或者距离底部较近（100px以内），则滚动到底部
          if (force || distanceToBottom < 100) {
            container.scrollTop = scrollHeight;
          }
        }
      });
    },

    scheduleScrollToBottom() {
      if (!this.scrollTimer) {
        this.scrollTimer = setTimeout(() => {
          this.scrollToBottom();
          this.scrollTimer = null;
        }, 50);
      }
    },

    // 时间格式化
    formatTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      const second = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },

    // 历史记录相关方法
    async getHistory() {
      try {
        this.loadingMore = true;
        const res = await deepseekList({
          platForm: this.platForm,
          userId: this.userId,
        });

        this.processHistoryResponse(res.data.data);
        if (this.currentChatId) {
          const current = this.chatHistory.find(
            (chat) => chat.id === this.currentChatId
          );
          if (current && current.conversationId) {
            this.currentChat.conversationId = current.id;
          }
        }
      } catch (err) {
        console.error("加载失败:", err);
        this.$toast('加载更多失败');
        this.currentPage = Math.max(1, this.currentPage - 1);
      } finally {
        this.loadingMore = false;
        this.needRefreshHistory = false;
      }
    },

    // 修改 processHistoryResponse 方法
    processHistoryResponse(newData) {
   const data = Array.isArray(newData) ? newData : [];

  if (this.currentPage === 1) {
    this.chatHistory = data.map(chat => ({
      id: chat.id,
      title: chat.title || '新对话',
      conversationId: chat.conversationId || chat.conversation_id || null,
      messages: chat.messages || [],
      updatedAt: chat.updatedAt || new Date().toISOString(),
    }));
    // 首页数据不足一页，说明无更多
    this.hasMore = data.length >= this.pageSize;
  } else {
    const mappedData = data.map(chat => ({
      id: chat.id,
      title: chat.title || '新对话',
      conversationId: chat.conversationId || chat.conversation_id || null,
      messages: chat.messages || [],
      updatedAt: chat.updatedAt || new Date().toISOString(),
    }));

    if (mappedData.length === 0) {
      this.hasMore = false;
    } else {
      this.chatHistory.push(...mappedData);
      this.hasMore = mappedData.length >= this.pageSize;
    }
  }

  this.historyTypeList = this.groupByDay(this.chatHistory);

  // 处理当前聊天
  if (this.chatHistory.length === 0) {
    this.newChat();
  } else if (!this.currentChatId || !this.chatHistory.find(c => c.id === this.currentChatId)) {
    this.currentChatId = this.chatHistory[0].id;
    this.currentChat.conversationId = this.chatHistory[0].id;
    this.getMessageInfo();
  } else {
    const current = this.chatHistory.find(c => c.id === this.currentChatId);
    if (current) {
      this.currentChat.conversationId = current.id;
    }
  }
    },
    
    getMessageInfo() {
      deepseekChatMessage({ conversationId: this.currentChatId }).then(
        (res) => {
          const data = res.data.data;
          data.forEach((e) => {
            e.timestamp = Date.parse(e.createdAt);
          });
          this.currentChat.messages = res.data.data;
          
          // 加载消息后滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom(true);
          });
        }
      );
    },

    async deleteChat(chat) {
      try {
        await this.$dialog.confirm({
          title: '确认',
          message: '是否确认删除？'
        });
        await deepseekdel({ id: chat.id });

        // 从历史记录中移除
        const index = this.chatHistory.findIndex((c) => c.id === chat.id);
        if (index !== -1) {
          this.chatHistory.splice(index, 1);
        }

        // 如果删除的是当前聊天，切换到第一个
        if (this.currentChatId === chat.id) {
          this.currentChatId = this.chatHistory[0]?.id || null;
          if (!this.currentChatId) {
            this.newChat();
          }
        }

        this.historyTypeList = this.groupByDay(this.chatHistory);
        this.$toast('删除成功');
      } catch (error) {
        // 用户取消或删除失败，不做任何操作
      }
    },

    groupByDay(data) {
      const grouped = {};
      data.forEach((item) => {
        const date = item.updatedAt
          ? item.updatedAt.split(" ")[0]
          : new Date().toISOString().split("T")[0];
        if (!grouped[date]) {
          grouped[date] = [];
        }
        grouped[date].push(item);
      });

      return Object.keys(grouped)
        .sort((a, b) => new Date(b) - new Date(a))
        .map((date) => ({
          date: date,
          items: grouped[date],
        }));
    },

   async loadMore() {
      if (this.loadingMore || !this.hasMore || this.currentPage <= 0) return;

  this.loadingMore = true; // 显式设置
  this.currentPage++;

  try {
    await this.getHistory();
  } catch (err) {
    console.error("加载更多失败:", err);
    this.$toast('加载失败');
    this.currentPage--; // 回退页码
  } finally {
    // this.loadingMore 在 getHistory 的 finally 中已设为 false
  }
    },

    toggleSidebar() {
      this.sidebarActive = !this.sidebarActive;
    },
  },

  mounted() {
    this.userId = this.$route.query.userId
    this.userName = this.$route.query.userName
    this.platForm = this.$route.query.platForm
    // this.oriApi = this.$route.query.oriApi
    this.getHistory();
    
    // 确保DOM完全渲染后再滚动
    this.$nextTick(() => {
      setTimeout(() => {
        this.scrollToBottom(true);
      }, 100);
    });
  },

  beforeDestroy() {
    this.stopStream();
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
  },

  // 监听消息变化自动滚动
  watch: {
    'currentChat.messages': {
      handler() {
        this.scheduleScrollToBottom();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
/* 基础样式重置 */
* {
  box-sizing: border-box;
}

#h5Index {
  display: flex;
  flex-direction: column;
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

/* 侧边栏样式 */
.sidebar {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
  padding: 10px 0;
}

.sidebar-header {
  padding: 0 16px 16px;
}

.history-group {
  margin-bottom: 16px;
}

.history_date {
  display: block;
  padding: 8px 16px;
  color: #969799;
  font-size: 12px;
  line-height: 16px;
}

.history_item_delete {
  color: #ee0a24;
  font-size: 16px;
}

.van-cell__title {
  word-break: break-all;
  white-space: normal;
  line-height: 1.5;
}

.active {
  background-color: #e6f7ff !important;
}

.sidebar-footer {
  margin-top: auto;
  padding: 16px;
  display: flex;
  align-items: center;
}

.user-avatar {
  font-size: 24px;
  margin-right: 8px;
  color: #1989fa;
}

.user-name {
  font-size: 14px;
  color: #323233;
}

.empty-tips {
  text-align: center;
  color: #969799;
  padding: 32px 0;
}

.empty-tips i,
.empty-tips .van-icon {
  display: block;
  margin: 0 auto 8px;
  color: #c8c9cc;
}

/* 主内容区域 - 关键修改 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
  height: 100vh;
  overflow: hidden; /* 防止外部滚动 */
}

/* 聊天容器包装器 - 新增 */
.chat-container-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0; /* 重要：允许内部滚动 */
}

/* 聊天容器 - 关键修改 */
.chat-container {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.chat-content {
  flex: 1;
  min-height: min-content; /* 重要：确保内容可以扩展 */
}

.message {
  display: flex;
  margin-bottom: 16px;
  max-width: 100%;
}

.message.user {
  flex-direction: row-reverse;
}

.message.user .message-content {
  background: #1989fa;
  color: white;
  border-radius: 18px 18px 0 18px;
  align-self: flex-end;
}

.message.assistant .message-content {
  background: #f7f8fa;
  color: #323233;
  border-radius: 18px 18px 18px 0;
  align-self: flex-start;
}

.message-content {
  padding: 12px 16px;
  max-width: 80%;
  position: relative;
  font-size: 14px;
  line-height: 1.5;
}

.message-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
}

.message-time {
  font-size: 10px;
  color: #969799;
  text-align: right;
  margin-top: 4px;
}

.typing {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #f7f8fa;
  border-radius: 18px 18px 18px 0;
  max-width: 80%;
  margin-bottom: 16px;
}

.typing-indicator {
  display: flex;
  align-items: center;
}

.typing-indicator span {
  margin-left: 8px;
  color: #969799;
  font-size: 14px;
}

.empty-chat {
  text-align: center;
  color: #969799;
  padding: 60px 0;
}

.empty-chat .van-icon {
  display: block;
  margin: 0 auto 16px;
  font-size: 40px;
  color: #c8c9cc;
}

.empty-chat h3 {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: normal;
  color: #323233;
}

.empty-chat p {
  margin: 0;
  font-size: 14px;
}

/* 输入区域 */
.input-area {
  border-top: 1px solid #ebedf0;
  background: #fff;
  padding: 8px 16px;
  flex-shrink: 0; /* 防止输入区域被压缩 */
}

.input-container {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.input-container .van-field {
  flex: 1;
  padding: 0;
  margin: 0;
}

.send-button {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.send-button.disabled {
  opacity: 0.5;
}

.input-tips {
  font-size: 12px;
  color: #969799;
  text-align: right;
  padding: 4px 0;
  height: 16px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .message-content {
    max-width: 90%;
  }
  
  .input-container {
    gap: 4px;
  }
  
  .send-button {
    width: 36px;
    height: 36px;
  }
  
  .chat-container {
    padding: 12px;
  }
}
.user .message-time{
color: #fff;
}
</style>